import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {AuditService } from '../services/audit.services';
import {MatTableDataSource} from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { IAuditData } from '../audit-trail/audit-data';
import { MatSort} from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from "@angular/common";
import { AuthService } from 'src/app/user/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss']
})
export class AuditTrailComponent implements OnInit, OnDestroy{

  private subs = new Subscription();

  displayedColumns: string[] = ['date_change', 'username', 'module', 'action', 'table_name'];
  
  public dataSource: MatTableDataSource<IAuditData>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private dataArray: any;
  public auditForm:FormGroup;
  farmattedDate: string;

  constructor(private service : AuditService, private router: Router, private authService: AuthService, private dialogRef: MatDialogRef<AuditTrailComponent>, private datePipe: DatePipe,){}

  ngOnInit() {
    this.subs.add(this.service.getData().subscribe((res) => {
        this.dataArray = res;
        this.dataSource = new MatTableDataSource<IAuditData>(this.dataArray);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        (err: HttpErrorResponse) => {
          if(err.status == 401) {
            this.authService.logout();
            this.dialogRef.close();
            this.router.navigate(['/user/login']);
          } else {
              (err) => console.log("Error while get all audit data: ", err)
            }          
          }
        )
      );
    }

  exportexcel(): void {
    // let element = document.getElementById('excel-table');
    // const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    // const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    // const blob: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    // FileSaver.saveAs(blob, 'Data.xlsx');


    let Heading = [['Date', 'User', 'Module', 'Action', 'Table']];

    //Had to create a new workbook and then add the header
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, Heading);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, this.dataArray, { origin: 'A2', skipHeader: true });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    let farmattedDate =this.datePipe.transform(new Date(), "yyyy.MM.dd HH:mm:ss");

    XLSX.writeFile(wb, "AuditTrail_" + farmattedDate + ".xlsx");
}
  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
}